import { render, staticRenderFns } from "./AttributionSmsReminderModal.vue?vue&type=template&id=10399f2c"
import script from "./AttributionSmsReminderModal.vue?vue&type=script&lang=js"
export * from "./AttributionSmsReminderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports